export const ButtonBootstrapStyle = {
    border: 'none',
    backgroundColor: '#fc3434',
    padding: '5px 10px',
    borderRadius: '13px',
    outline: 'none',
    fontSize: '20px',
    color: 'white',
}

